export default __webpack_public_path__ + "static/media/vc-unmute.c2221791.svg";